import { render, staticRenderFns } from "./BlogPage.vue?vue&type=template&id=22291378&"
import script from "./BlogPage.vue?vue&type=script&lang=ts&"
export * from "./BlogPage.vue?vue&type=script&lang=ts&"
import style0 from "./BlogPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports